<template>
  <div class="five">

    <!-- Hero 区域 -->
    <div class="cgal">
      <div class="cgal-container">
        <div class="cgal-title">全域营销数据总览</div>
        <p style="text-align: center">通过精准策略驱动品牌增长</p>
        <div class="cgal-content">
          <div class="con">
            <div class="item">
              <div class="icon">
                <img src="../../assets/images/success/cgal1.png" alt="">
              </div>
              <div class="text">
                <div class="xxl-text">4600万+</div>
                <div class="n-text">季度GMV</div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="../../assets/images/success/cgal2.png" alt="">
              </div>
              <div class="text">
                <div class="xxl-text">1.87</div>
                <div class="n-text">保健奶粉领先达2.0</div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="../../assets/images/success/cgal3.png" alt="">
              </div>
              <div class="text">
                <div class="xxl-text">30%</div>
                <div class="n-text">高价值人群增长</div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="../../assets/images/success/cgal4.png" alt="">
              </div>
              <div class="text">
                <div class="xxl-text">2600万</div>
                <div class="n-text">爆款案例</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  成功案例  区域  -->
    <div class="data">
      <div class="data-container">
        <div class="data-title">
          <div class="text">成功案例</div>
          <div class="searchDiv">
            <el-select style="width: 130px" size="small" v-model="hy" clearable placeholder="按行业分类"
              @change="getDataList">
              <el-option v-for="item in hyOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select style="width: 130px" size="small" v-model="fwlx" clearable placeholder="按服务类型"
              @change="getDataList">
              <el-option v-for="item in fwlxOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input @keyup.enter.native="getDataList" @input="getDataList" clearable style="width: 240px" size="small"
              v-model="name" placeholder="搜索案例..." prefix-icon="el-icon-search"></el-input>
          </div>
        </div>
        <div class="data-content">
          <div class="con">
            <div class="item" v-for="(item, i) in dataList" :key="i">
              <div class="content">
                <div class="type">
                  <div class="text ellipsis" :title="item.name">{{ item.name }}</div>
                  <div class="tag">
                    <el-tag :title="item.industryType" class="ellipsis" size="small">{{ item.industryType }}</el-tag>
                    <el-tag :title="item.serveType" class="ellipsis" size="small">{{ item.serveType }}</el-tag>
                  </div>
                </div>
                <div class="detail">
                  <div class="challenge detail-item">
                    <img src="../../assets/images/success/icon1.png" alt="">
                    <div class="ellipsis" :title="item.challenge">{{ item.challenge }}</div>
                  </div>
                  <div class="strategy detail-item">
                    <img src="../../assets/images/success/icon2.png" alt="">
                    <div class="ellipsis" :title="item.strategy">{{ item.strategy }}</div>
                  </div>
                  <div class="achievement detail-item">
                    <img src="../../assets/images/success/icon3.png" alt="">
                    <div class="ellipsis" :title="item.achievement">{{ item.achievement }}</div>
                  </div>
                </div>
              </div>
              <div class="foot">
                <el-button type="primary" size="medium" @click="showDetail(item.detailUrl)">查看详情</el-button>
              </div>
            </div>
          </div>

          <div v-if="dataList.length === 0">
            <TableNoData />
          </div>

          <pagination v-show="total > 0" :total="total" :page.sync="pageNum" :limit.sync="pageSize"
            @pagination="getDataList" />
        </div>
      </div>
    </div>

    <!-- 详情对话框 -->
    <el-dialog title="查看详情" :visible.sync="detailOpen" width="1000px" append-to-body>
      <div style="text-align: center">
        <el-image v-if="detailUrl" :src="detailUrl" width="900" fit="cover" preview-teleport="body" />
        <img v-else width="900" src="../../assets/images/成功案例详情页.png" alt="">
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="closeDetail">关 闭</el-button>
        </div>
      </template>
    </el-dialog>


  </div>
</template>

<script>
import { getCaseList, getIndustryTypeList, getServeTypeList } from "@/apis/cms";
import TableNoData from "@/components/TableNoData/index.vue";

export default {
  components: { TableNoData },
  data() {
    return {
      detailOpen: false,
      detailUrl: '',
      pageNum: 1,
      pageSize: 8,
      total: 0,
      name: '',
      hy: '',
      fwlx: '',
      hyOptions: [
        { label: '行业1', value: '1' },
        { label: '行业2', value: '2' },
        { label: '行业3', value: '3' },
      ],
      fwlxOptions: [
        { label: '服务1', value: '1' },
        { label: '服务2', value: '2' },
        { label: '服务3', value: '3' },
      ],
      dataList: [
        {
          id: '1',
          name: '保健/药品保健/药品保健/药品',
          serveType: '数据看板数据看板',
          industryType: '数据看板数据看板',
          challenge: '成熟产品线持续增长成熟产品线持续增长成熟产品线持续增长',
          strategy: '公私域组合拳公私域组合拳公私域组合拳',
          achievement: '季度 GMV 600 万+，ROI 2，高价值人群增长 30%价值人群增长 30%',
        },
        {
          id: '2',
          name: '蓝河羊奶粉',
          serveType: '私域运营',
          industryType: '数据看板',
          challenge: '建立市场信任',
          strategy: 'KOC 私域资源集中引爆',
          achievement: '18 天 2600 万产出',
        },
        {
          id: '3',
          name: '冠能宠物品牌',
          serveType: '公域投放',
          industryType: '数据看板',
          challenge: '大促销量爆发保障 ROI',
          strategy: '不设限投放聚焦拉新',
          achievement: '双月 GMV 500 万+，ROI 1.8',
        },
        {
          id: '4',
          name: '3C/电器',
          serveType: '全域整合',
          industryType: '数据看板',
          challenge: '大促销量爆发保障 ROI',
          strategy: '不设限投放聚焦拉新',
          achievement: '双月 GMV 500 万+，ROI 1.8',
        },
        {
          id: '5',
          name: '个护/彩妆',
          serveType: '数据看板',
          industryType: '数据看板',
          challenge: '大促销量爆发保障 ROI',
          strategy: '不设限投放聚焦拉新',
          achievement: '双月 GMV 500 万+，ROI 1.8',
        },
        {
          id: '6',
          name: '食品/酒水 CID',
          serveType: '私域运营',
          industryType: '数据看板',
          challenge: '大促销量爆发保障 ROI',
          strategy: '不设限投放聚焦拉新',
          achievement: '双月 GMV 500 万+，ROI 1.8',
        },
        {
          id: '7',
          name: '汽配',
          serveType: '公域投放',
          industryType: '数据看板',
          challenge: '大促销量爆发保障 ROI',
          strategy: '不设限投放聚焦拉新',
          achievement: '双月 GMV 500 万+，ROI 1.8',
        },
        {
          id: '8',
          name: '快消 UDS',
          serveType: '全域整合',
          industryType: '数据看板',
          challenge: '大促销量爆发保障 ROI',
          strategy: '不设限投放聚焦拉新',
          achievement: '双月 GMV 500 万+，ROI 1.8',
        },
      ]
    };
  },
  created() {
    this.initPage();
  },
  methods: {
    showDetail(detailUrl) {
      if (detailUrl) {
        this.detailUrl = detailUrl
      }
      this.detailOpen = true;
    },
    closeDetail() {
      this.detailOpen = false;
    },
    initPage() {
      this.getAllIndustryTypeList();
      this.getServeTypeList();
      this.getDataList();
    },
    getAllIndustryTypeList() {
      getIndustryTypeList().then(res => {
        console.log('getIndustryTypeList', res)
        if (res.code === 200) {
          this.hyOptions = res.data;
        }
      })
    },
    getServeTypeList() {
      getServeTypeList().then(res => {
        console.log('getServeTypeList', res)
        if (res.code === 200) {
          this.fwlxOptions = res.data;
        }
      })
    },
    getDataList() {
      this.dataList = [];
      const params = {
        industryType: this.hy,
        serveType: this.fwlx,
        name: this.name,
        // 补充缺失的分页参数（原代码遗漏，会导致分页功能失效）
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getCaseList(params).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.dataList = res.data.rows;
        }
      })
    }
  },
};
</script>

<style lang='scss' scoped>
.el-dialog__body {
  background-color: #f9fafb;
}

.tc-dialog {
  display: flex;
  gap: 30px;

  .item {
    flex: 1;
    padding: 20px;
    background-color: #ffffff;
    border: 1px solid #f4f4f5;
    /* 可选：添加实体边框，与虚影搭配 */
    border-radius: 15px;
    box-shadow: 0 0 10px #ebecec;
    /* 核心属性 */

    .d-title {
      font-size: x-large;
      font-weight: bold;
    }

    .m-text {
      padding: 10px 0;

      span {
        font-size: x-large;
        font-weight: bold;
        color: #296eed;
      }
    }

    .d-text {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .d-text-item {
        font-size: 14px;

        i {
          color: #22c55e;
        }

        span {
          padding-left: 5px;
        }
      }
    }
  }
}

.five {
  background-color: #F9FAFB;
  font-size: 15px;

  .cgal {
    width: 100%;

    height: 600px;
    padding-top: 50px;
    background-color: #FFE4E6;

    .cgal-container {
      width: 80%;
      background-color: #ffffff;
      border: 1px solid #f4f4f5;
      /* 可选：添加实体边框，与虚影搭配 */
      border-radius: 15px;
      box-shadow: 0 0 10px #ebecec;
      /* 核心属性 */
      margin: 60px auto 0;

      .cgal-title {
        text-align: center;
        padding: 40px 20px 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .cgal-content {
        margin-left: 50px;
        margin-top: 30px;

        .con {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          gap: 50px;
          padding-bottom: 50px;

          .item {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #fdfdfe;
            border: 1px solid #f4f4f5;
            /* 可选：添加实体边框，与虚影搭配 */
            border-radius: 15px;
            box-shadow: 0 0 10px #ebecec;
            /* 核心属性 */
            height: 230px;
            text-align: center;

            .icon {
              img {
                width: 70px;
                height: 70px;
              }
            }

            .text {
              padding-top: 10px;

              .xxl-text {
                font-size: xxx-large;
                font-weight: bold;

              }

              .n-text {}
            }


          }
        }

      }
    }

  }


  .data {
    width: 100%;
    min-height: 600px;
    padding: 0 0 50px 0;

    .data-container {
      width: 80%;
      //background-color: #ffffff;
      //border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
      //border-radius: 15px;
      //box-shadow: 0 0 10px #ebecec; /* 核心属性 */
      margin: 60px auto 0;

      .data-title {
        display: flex;
        justify-content: space-between;

        .text {
          font-size: xx-large;
          font-weight: bold;
        }

        .searchDiv {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 15px;
        }
      }

      .data-content {
        padding-top: 40px;

        ::v-deep .active {
          background-color: #E33333;
        }

        .con {
          display: flex;
          flex-wrap: wrap;
          /* 核心：多余子元素换行 */
          gap: 50px;

          /* 子元素之间的间距（水平+垂直间距一致，可选） */
          .item {
            flex: 0 0 calc((100% - 3 * 50px) / 4);
            max-width: calc((100% - 3 * 50px) / 4);
            height: 265px;
            border: 1px solid #f4f4f5;
            /* 可选：添加实体边框，与虚影搭配 */
            border-radius: 15px;
            box-shadow: 0 0 10px #ebecec;
            /* 核心属性 */

            .content {
              width: 100%;
              background-color: #FFFFFF;
              border-top-left-radius: 15px;
              border-top-right-radius: 15px;
              height: 200px;
              padding: 20px;

              .ellipsis {
                white-space: nowrap;
                /* 单行不换行 */
                overflow: hidden;
                /* 溢出隐藏 */
                text-overflow: ellipsis;
                /* 显示省略号 */
              }

              .type {
                display: flex;
                justify-content: space-between;

                .text {
                  max-width: 48%;
                  font-size: large;
                  font-weight: bold;
                }

                .tag {
                  width: 53%;
                  display: flex;
                  justify-content: flex-end;
                  gap: 6px;

                  .el-tag {
                    width: 50%;
                    text-align: center;
                    background-color: #FFE4E6;
                    color: #E33333;
                  }
                }
              }

              .detail {
                padding-top: 22px;
                flex-direction: column;
                display: flex;
                gap: 20px;

                .detail-item {
                  display: flex;
                }

                img {
                  width: 20px;
                  height: 20px;
                  margin-right: 8px;
                }
              }
            }

            .foot {
              padding: 15px 20px;

              button {
                width: 100%;
                background-color: #E33333;
                border-color: #FF6700;
              }
            }

          }
        }
      }

    }

  }


}
</style>
